//表情
const FACEICONSNAME = [
  "[龇牙]",
  "[调皮]",
  "[流汗]",
  "[偷笑]",
  "[再见]",
  "[敲打]",
  "[擦汗]",
  "[猪头]",
  "[玫瑰]",
  "[流泪]",
  "[大哭]",
  "[嘘]",
  "[酷]",
  "[抓狂]",
  "[委屈]",
  "[便便]",
  "[炸弹]",
  "[菜刀]",
  "[可爱]",
  "[色]",
  "[害羞]",
  "[得意]",
  "[吐]",
  "[微笑]",
  "[怒]",
  "[尴尬]",
  "[惊恐]",
  "[冷汗]",
  "[爱心]",
  "[示爱]",
  "[白眼]",
  "[傲慢]",
  "[难过]",
  "[疑问]",
  "[困]",
  "[么么哒]",
  "[憨笑]",
  "[衰]",
  "[撇嘴]",
  "[阴险]",
  "[奋斗]",
  "[发呆]",
  "[右哼哼]",
  "[抱抱]",
  "[坏笑]",
  "[鄙视]",
  "[晕]",
  "[可怜]",
  "[强]",
  "[弱]",
  "[握手]",
  "[胜利]",
  "[抱拳]",
  "[凋谢]",
  "[米饭]",
  "[蛋糕]",
  "[西瓜]",
  "[啤酒]",
  "[瓢虫]",
  "[勾引]",
  "[OK]",
  "[爱你]",
  "[咖啡]",
  "[刀]",
  "[差劲]",
  "[拳头]",
  "[心碎了]",
  "[太阳]",
  "[礼物]",
  "[皮球]",
  "[骷髅]",
  "[闪电]",
  "[饥饿]",
  "[困]",
  "[咒骂]",
  "[折磨]",
  "[抠鼻]",
  "[鼓掌]",
  "[糗大了]",
  "[左哼哼]",
  "[打哈欠]",
  "[快哭了]",
  "[吓]",
  "[篮球]",
  "[乒乓]",
  "[NO]",
  "[闭嘴]",
  "[猫咪]",
  "[红双喜]",
  "[鞭炮]",
  "[红灯笼]",
  "[麻将]",
  "[麦克风]",
  "[礼品袋]",
  "[信封]",
  "[象棋]",
  "[彩带]",
  "[蜡烛]",
  "[爆筋]",
  "[棒棒糖]",
  "[奶瓶]",
  "[面条]",
  "[香蕉]",
  "[飞机]",
  "[左车头]",
  "[车厢]",
  "[右车头]",
  "[多云]",
  "[下雨]",
  "[钞票]",
  "[熊猫]",
  "[灯泡]",
  "[风车]",
  "[闹钟]",
  "[雨伞]",
  "[彩球]",
  "[钻戒]",
  "[沙发]",
  "[纸巾]",
  "[手枪]",
  "[青蛙]",
];
export class ChatUtils {

  static emolist = [];
  //渲染键盘的表情包
  static renderBq() {
    if (ChatUtils.emolist.length > 0) {
      return ChatUtils.emolist;
    }
    for (let i = 0; i < FACEICONSNAME.length; i++) {
      const element = FACEICONSNAME[i];
      let obj = {};
      const img = require("@/assets/emoji/" + element + "@2x.png");
      obj["name"] = element;
      obj["img"] = img;
      ChatUtils.emolist.push(obj);
    }
    return ChatUtils.emolist;
  }

  static arrTrans(num, arr) {
    // 一维数组转换为二维数组
    const iconsArr = []; // 声明数组
    arr.forEach((item, index) => {
      const page = Math.floor(index / num); // 计算该元素为第几个素组内
      if (!iconsArr[page]) {
        // 判断是否存在
        iconsArr[page] = [];
      }
      iconsArr[page].push(item);
    });
    return iconsArr;
  }

  static createHtml(text) {
    // text = text.replace(/>/g, "}");
    text = text.replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      // .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
    // console.log('text',text);
    let dom;
    let urls = ChatUtils.getUrlFromContent(text);
    if (urls && urls.length > 0) {
      dom = ChatUtils.decodeUrl(text, urls);
    } else {
      dom = ChatUtils.decodeText(text);
    }


    let div = "";
    for (let i = 0; i < dom.length; i++) {
      let element = dom[i];
      div = div + ChatUtils.createEle(element);
    }
    // console.log('div',div);
    return div;
  }

  static createEle(ele) {
    // toLocationBrowser(Platform.down68)
    if (ele.name == "a") {
      // return `<a  style="color: #0000ee;text-decoration:underline;">${ele.text}</a>`
      return `<a target="_blank"  href="${ele.text}" style="color: #0000ee;text-decoration:underline;">${ele.text}</a>`
    }

    if (ele.name == "text") {
      return `<span>${ele.text}</span>`;
    } else if (ele.name == "img") {
      const img = require("@/assets/emoji/" + ele.src + "@2x.png");
      return ` <img src="${img}" style="width: 20px;height: 20px;display: inline-block;vertical-align: middle;" />`;
    }
    return `<span></span>`;
  }

  static decodeUrl(text, urls) {
    let dom = [];
    if (urls && urls.length > 0) {
      let decodeStr = text;
      for (let i = 0; i < urls.length; i++) {
        let idx = decodeStr.indexOf(urls[i])
        let str = decodeStr.substring(0, idx);
        dom.push({ name: 'text', text: str })
        dom.push({ name: 'a', text: urls[i] })
        decodeStr = decodeStr.substring(idx + urls[i].length, decodeStr.length);
      }
      if (decodeStr.length > 0) {
        dom.push({ name: 'text', text: decodeStr })
      }
    } else {
      dom.push({ name: 'text', text: text })
    }
    return dom;
  }

  static isEmoji(name) {
    for (let i = 0; i < FACEICONSNAME.length; i++) {
      if (FACEICONSNAME[i] === name) {
        return true;
      }
    }
    return false;
  }

  static getUrlFromContent(text) {
    if (!text) {
      return text;
    }
    const reg = /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
    let result = text.match(reg);
    return result;
  }

  static decodeText(text) {
    let dom = [];
    let temp = text;
    let left = -1;
    let right = -1;
    while (temp !== "" && typeof temp !== "undefined") {
      left = temp.indexOf("[");
      right = temp.indexOf("]");
      switch (left) {
        case 0:
          if (right == -1) {
            dom.push({ name: "text", text: temp });
            temp = "";
          } else {
            let _emoji = temp.slice(0, right + 1);
            if (ChatUtils.isEmoji(_emoji)) {
              dom.push({ name: "img", src: _emoji });
              temp = temp.substring(right + 1);
            } else {
              dom.push({ name: "text", text: "[" });
              temp = temp.slice(1);
            }
          }
          break;
        case -1:
          dom.push({ name: "text", text: temp });
          temp = "";
          break;
        default:
          dom.push({ name: "text", text: temp.slice(0, left) });
          temp = temp.substring(left);
          break;
      }
    }

    return dom;
  }
}
